/**
 * Fixes Stripe Buy Button amount field editing.
 * Stripe's embedded input blocks typing after the decimal unless all text is selected.
 * On focus, we select all so customers can type the amount naturally.
 */
(function () {
  function collectInputs(root, list) {
    if (!root) return list;

    root.querySelectorAll('input').forEach(function (input) {
      list.push(input);
    });

    root.querySelectorAll('*').forEach(function (node) {
      if (node.shadowRoot) {
        collectInputs(node.shadowRoot, list);
      }
    });

    return list;
  }

  function isAmountInput(input) {
    if (!input || input.type === 'hidden') return false;
    var type = (input.getAttribute('type') || 'text').toLowerCase();
    return type === 'text' || type === 'number' || type === 'tel';
  }

  function enhanceInput(input) {
    if (!isAmountInput(input) || input.dataset.sqpAmountFix === 'true') return;
    input.dataset.sqpAmountFix = 'true';

    function selectAll() {
      try {
        input.focus({ preventScroll: true });
        input.select();
        if (typeof input.setSelectionRange === 'function') {
          input.setSelectionRange(0, input.value.length);
        }
      } catch (error) {
        /* ignore */
      }
    }

    input.addEventListener('pointerdown', function () {
      if (document.activeElement !== input) {
        setTimeout(selectAll, 0);
      }
    });

    input.addEventListener('focus', function () {
      setTimeout(selectAll, 0);
    });

    input.addEventListener('click', function () {
      setTimeout(selectAll, 0);
    });
  }

  function enhanceBuyButton(button) {
    if (!button || button.dataset.sqpAmountWatch === 'true') return;
    button.dataset.sqpAmountWatch = 'true';

    function scan() {
      collectInputs(button.shadowRoot, []).forEach(enhanceInput);
    }

    scan();

    var observer = new MutationObserver(scan);
    if (button.shadowRoot) {
      observer.observe(button.shadowRoot, { childList: true, subtree: true });
    }

    var attempts = 0;
    var interval = window.setInterval(function () {
      scan();
      attempts += 1;
      if (attempts > 40) {
        window.clearInterval(interval);
      }
    }, 250);
  }

  function init() {
    document.querySelectorAll('stripe-buy-button').forEach(enhanceBuyButton);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var pending = false;
  var bodyObserver = new MutationObserver(function () {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(function () {
      pending = false;
      init();
    });
  });
  bodyObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
